<template>
    <a @click="handleClick" class="btn" >
        {{ title }}
    </a>
</template>

<script>
export default {
  name:'btn',
  props:{
    title:{
    type:String,
        default:'分享'
    },
  },
  methods:{
    handleClick(){
      this.$emit('shareClick');
    },
  }
}
</script>

<style lang="less">
.btn {
  width: 312px;
  height: 64px;
  margin: 0 auto;
  background: #656EE3;
  border-radius: 32px;
  border: 2px solid #656EE3;
  display: flex;
  align-items: center;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  justify-content: center;
}
</style>
